module.exports = __webpack_public_path__ + "img/LS.9fc380a6.svg";